
/**
 * Custom Cluster Renderer class
 */
export class ClusterRenderer {

    /**
     * 
     * @param config
     */
    constructor(config = {}) {
        const {isSold} = {isSold: false, ...config};
        this._isSold = !!isSold;
    }

    /**
     * 
     * @returns {*}
     */
    get isSold() {
        return this._isSold;
    }

    /**
     * 
     * @param value
     */
    set isSold(value) {
        this._isSold = !!value;
    }
    
    getClusterMarkerColor() {
        return this.isSold ? '#E74C3C' : '#3D465E';
    }
    
    render({count, position}) {
       const markerIcon = this.getMarkerIcon();

       let marker = new google.maps.Marker({
           label: this.getMarkerLabel(count),
           icon: markerIcon,
           position,
           title: (count > 1 ? `At least ${count} properties` : '1 property ')
               + ' matching search criteria found in this area.',
           // adjust zIndex to be above other markers
           zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
       });

       return marker;
    }

    getMarkerLabel(count) {
        return {
            text: count > 9 ? '9+' : String(count),
            color: "white",
            fontSize: "0.75rem",
            fontWeight: "bold",
        };
    }

    getMarkerIcon() {
        const svg = window.btoa(`
            <svg
                fill="${this.getClusterMarkerColor()}"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
            >
                <circle
                    cx="16"
                    cy="16"
                    r="9"
                    stroke="white"
                    stroke-width="2"
                    style="filter: drop-shadow(0 0 3px rgb(228, 228, 230, 0.8))"
                />
            </svg>
        `);

        return {
            url: `data:image/svg+xml;base64,${svg}`,
        };
    }
}
